import React from "react";
import { Card, Form, Input, Button, message } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  MessageOutlined,
  ClockCircleOutlined,
  SendOutlined
} from "@ant-design/icons";
import "./Public.css";

const ContactUsPage = () => {
  const [form] = Form.useForm();

  const handleFinishSubmit = (values) => {
    // Faux-submission alert
    message.success("Thank you for contacting us! Our administration team will get back to you shortly.");
    form.resetFields();
  };

  return (
    <div className="privacy-page-container">
      {/* Hero Header */}
      <header className="privacy-hero">
        <div className="privacy-hero-content">
          <span className="privacy-badge">Get In Touch</span>
          <h1 className="privacy-title">Contact IAmDojo</h1>
          <p className="privacy-subtitle">
            Have questions about enrollments, class schedules, or dashboard access? Reach out to us.
          </p>
        </div>
      </header>

      {/* Main Content Layout */}
      <main className="privacy-content-simple">
        <div className="policy-cards-stack">
          {/* Card 1: Direct Support Details */}
          <Card className="policy-card" bordered={false}>
            <div className="card-header-flex">
              <div className="card-icon-wrapper">
                <MessageOutlined />
              </div>
              <h2 className="card-title-text">Direct Contact Channels</h2>
            </div>

            <div className="card-body-text">
              <p>
                Our administration staff is available to respond to your queries promptly. You can connect with us directly via the following methods:
              </p>

              <div className="contact-info-grid">
                <div className="contact-method-card">
                  <div className="contact-method-icon">
                    <MailOutlined />
                  </div>
                  <div className="contact-method-label">Email Channels</div>
                  <div className="contact-method-value">
                    <a href="mailto:yan@iamdojo.com" style={{ color: "#ea580c" }}>
                      yan@iamdojo.com
                    </a>
                    <br />
                    <a href="mailto:contact@IAmDojo-co.com" style={{ color: "#ea580c" }}>
                      contact@IAmDojo-co.com
                    </a>
                  </div>
                </div>

                <div className="contact-method-card">
                  <div className="contact-method-icon">
                    <PhoneOutlined />
                  </div>
                  <div className="contact-method-label">WhatsApp & Call</div>
                  <div className="contact-method-value">
                    <a href="https://wa.me/9626767292226" target="_blank" rel="noopener noreferrer" style={{ color: "#ea580c" }}>
                      +962 67672 92226
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Card 2: HQ and Hours */}
          <Card className="policy-card" bordered={false}>
            <div className="card-header-flex">
              <div className="card-icon-wrapper">
                <EnvironmentOutlined />
              </div>
              <h2 className="card-title-text">Dojo Administration Office</h2>
            </div>

            <div className="card-body-text">
              <p>
                If you prefer in-person registration or direct assistance, visit us at our administrative coordinates.
              </p>

              <div className="contact-info-grid">
                <div className="contact-method-card">
                  <div className="contact-method-icon">
                    <EnvironmentOutlined />
                  </div>
                  <div className="contact-method-label">Physical Dojo HQ</div>
                  <div className="contact-method-value" style={{ color: "#1c1917" }}>
                    IAmDojo Karate Institute
                    <br />
                    Main Training & Admin Office
                  </div>
                </div>

                <div className="contact-method-card">
                  <div className="contact-method-icon">
                    <ClockCircleOutlined />
                  </div>
                  <div className="contact-method-label">Office Hours</div>
                  <div className="contact-method-value" style={{ color: "#1c1917" }}>
                    Monday – Friday: 9:00 AM – 6:00 PM
                    <br />
                    Saturday: 10:00 AM – 4:00 PM
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Card 3: Interactive Submission Form */}
          <Card className="policy-card" bordered={false}>
            <div className="card-header-flex">
              <div className="card-icon-wrapper">
                <SendOutlined />
              </div>
              <h2 className="card-title-text">Send Us a Quick Message</h2>
            </div>

            <div className="card-body-text">
              <p>
                Fill out the quick inquiry form below and an administrative officer will contact you within 24 hours.
              </p>

              <Form
                form={form}
                layout="vertical"
                onFinish={handleFinishSubmit}
                style={{ marginTop: 24 }}
              >
                <Form.Item
                  name="name"
                  label={<span style={{ fontWeight: 600, color: "#44403c" }}>Your Name</span>}
                  rules={[{ required: true, message: "Please input your name" }]}
                >
                  <Input placeholder="Enter your full name" size="large" style={{ borderRadius: "8px" }} />
                </Form.Item>

                <Form.Item
                  name="email"
                  label={<span style={{ fontWeight: 600, color: "#44403c" }}>Your Email</span>}
                  rules={[
                    { required: true, message: "Please input your email" },
                    { type: "email", message: "Please enter a valid email address" }
                  ]}
                >
                  <Input placeholder="Enter your email address" size="large" style={{ borderRadius: "8px" }} />
                </Form.Item>

                <Form.Item
                  name="message"
                  label={<span style={{ fontWeight: 600, color: "#44403c" }}>Your Message</span>}
                  rules={[{ required: true, message: "Please enter your query details" }]}
                >
                  <Input.TextArea
                    rows={4}
                    placeholder="Describe your questions or requirements here..."
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    icon={<SendOutlined />}
                    style={{
                      borderRadius: "50px",
                      backgroundColor: "#ea580c",
                      borderColor: "#ea580c",
                      padding: "0 32px",
                      fontWeight: 600,
                      height: "auto",
                      lineHeight: "2.5"
                    }}
                  >
                    Submit Query
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Card>
        </div>
      </main>

      {/* Footer */}
      <footer className="privacy-footer">
        <div>
          © {new Date().getFullYear()} IAmDojo Karate Institute. All rights reserved. |{" "}
          <a href="/login">Terms of Service</a>
        </div>
      </footer>
    </div>
  );
};

export default ContactUsPage;
